import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { BaseProvider } from '../BaseProvider';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class TransactionsService extends BaseProvider {

    getTransactionsUrl = 'transactions?orderId=##ORDERID##';

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }

    getTransaction(orderId: string) {
        let url = this.getTransactionsUrl
            .replace("##ORDERID##", orderId);

        return this.makeGetCall(url);
    }
    patchTransaction(transactionId, transactionModel: any) {
        return this.makePatchCall("transactions/" + transactionId + "?transactionId=" + transactionId, transactionModel);
    }

    getTransactionsPaymentsList(startDate, endDate) {
        return this.makeGetCall("transactionsPayment?endDate=" + endDate + "&startDate=" + startDate);
    }

    deleteTransaction(id: any) {
        return this.makeDeleteCall("transactions/" + id);
    }

}


// WEBPACK FOOTER //
// ./src/app/_services/transactions/transactions.service.ts